module.exports = __webpack_public_path__ + "static/media/notFull.4d1d736e.svg";